import { Box, Typography } from '@mui/material';
import _ from 'lodash';
import React from 'react';
import { EventsPanel } from '../components/dashboard/EventsPanel';
import { SummaryPanel } from '../components/dashboard/SummaryPanel';
import { TasksPanel } from '../components/dashboard/TasksPanel';
import { useGetEmployeeById } from '../services/react-query/employees';
import { headerTypographyProps } from '../styles/sxStyling';

export default function Dashboard() {
  const { data: currentEmployeeData } = useGetEmployeeById({ uuid: 'current' });
  const displayName = _.first(_.filter(_.map([currentEmployeeData?.chosen_name, currentEmployeeData?.first_name, 'to ScheduLink'], _.trim)));

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      <Typography {...headerTypographyProps}>{`Welcome ${displayName}`}</Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: { xs: 2, sm: 1 } }}>
        <EventsPanel currentEmployeeUuid={currentEmployeeData?.uuid} />
        <TasksPanel currentEmployeeUuid={currentEmployeeData?.uuid} />
        <SummaryPanel />
      </Box>
    </Box>
  );
}
